module.exports = __webpack_public_path__ + "static/media/estat_usuarios_por_perfil.b76db1e9.png";